import './Disclaimer.css';

import React from 'react';
import { VentionLogo } from '@src/assets';

interface DisclaimerProps {
  onComplete: () => void
}

export const Disclaimer = ({ onComplete }: DisclaimerProps): JSX.Element => {
  return (
    <div id="disclaimer">
      <div id="disclaimer_header">
        <div className="vention-logo-container">
          <VentionLogo id="vention-logo"/>
        </div>
      </div>
      <div id="disclaimer_content">
        <Title />
        <DisclaimerMessage />
        <ContinueButton onClick={onComplete} />
      </div>
    </div>
  );
};

const Title = (): JSX.Element => (
  <span id="disclaimer_title">
    Welcome to Vention
  </span>
);

const DisclaimerMessage = (): JSX.Element => (
  <div id="disclaimer_message">
    <div id="disclaimer_label">Disclaimer</div>
    <div id="disclaimer_text">This product, and the associated equipment, if improperly assembled, installed, operated or maintained, may cause material damages and severe injuries, up to and including death. Please carefully follow all applicable assembly, installation, operation and maintenance instructions and always comply with all relevant rules, regulations, directives, norms and standards in order to ensure your safety and that of other users and operators of the product.</div>
  </div>
);

interface ContinueButtonProps {
  onClick: () => void
}

const ContinueButton = ({ onClick }: ContinueButtonProps): JSX.Element => (
  <button id="continue_button" className="green-button" onClick={onClick}>
    <span>Continue</span>
  </button>
);
